class EventBus {
  constructor() {
    this.subscriptions = {};
    this.guards = new Map();
  }

  on(event, callback, guard = null) {
    if (!this.subscriptions[event]) {
      this.subscriptions[event] = [];
    }

    this.subscriptions[event].push(callback);
    if (guard) {
      this.guards.set(callback, guard);
    }
  }

  dispatch(event, payload) {
    if (this.subscriptions[event]) {
      this.subscriptions[event].forEach((callback) => {
        if (this.guards.has(callback)) {
          const guard = this.guards.get(callback);
          if (guard(payload)) {
            callback(payload);
          }
        } else {
          callback(payload);
        }
      });
    }
  }

  unsubscribe(event, callback) {
    const index = this.subscriptions[event].indexOf(callback);
    if (index !== -1) {
      this.subscriptions[event].splice(index, 1);
    }
    if (this.guards.has(callback)) {
      this.guards.delete(callback);
    }
  }
}

export default EventBus;
